import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class BugService {
  constructor(private api: ApiService) {}

  getAllBugs(data: any): Observable<any> {
    return this.api.post(environment.getAllBugs, data);
  }
  createBug(data: any): Observable<any> {
    return this.api.post(environment.createBug, data);
  }
  updateBug(data: any): Observable<any> {
    return this.api.post(environment.updateBug, data);
  }
  deleteBug(data: any): Observable<any> {
    return this.api.post(environment.deleteBug, data);
  }
  getBugById(data: any): Observable<any> {
    return this.api.post(environment.getBugById, data);
  }
  getBugActivityLog(data: any): Observable<any> {
    return this.api.post(environment.getBugActivityLog, data);
  }
  getProjectModuleList(data: any): Observable<any> {
    return this.api.post(environment.getProjectModuleList, data);
  }
}
